export default __webpack_public_path__ + "static/media/facilitation_icon.a2c43ccf.webp";